// Contact.js

import ContactForm from "../../02-molecules/contactForm/ContactForm";
import SEO from "../../02-molecules/SEO/SEO";
import Breadcrumb from "../../01-atoms/breadcrumbs/Breadcrumbs";

const Contact = () => {
    return(
        <main className="secondary-page__content">
            <div className="wrapper wrapper-secondary">
                <Breadcrumb />
                
                <SEO
                    title='Contact Us | Ajit Furniture House'
                    description='Send Enquiry with detail description of your requirements'
                    name='Ajit Furniture House'
                    type='enquiry form'
                />

                <div className="content-container">
                    <div className="contact">
                        <div className="contact-text">
                            <div className="contact-heading">
                                <h2>GET IN TOUCH</h2>
                            </div>

                            <p className="contact-description">Thanks for stopping by! For any Furniture or Interior Decor needs, call us on the numbers at the bottom or fill out this form with detail description of your requirements & we will get back to you asap.</p>
                        </div>
                        <ContactForm />
                    </div>
                </div>
            </div>
        </main>
    )
}

export default Contact;
